module.exports = __webpack_public_path__ + "static/media/hero-section.af7e3540.mp4";